document.addEventListener("DOMContentLoaded", function () {
  let currencySymbol = window.Shopify?.currency?.symbol || "€";
  let params = new URLSearchParams(window.location.search);
  let variantData = JSON.parse(localStorage.getItem("variantData")) || {};

  let initialData = {
    title: params.get("product_title") || variantData.title || "N/A",
    color: params.get("color") || variantData.color || "N/A",
    size: params.get("size") || variantData.size || "N/A",
    pricePerMeter: variantData.pricePerMeter || 0,
    image: params.get("image")
      ? decodeURIComponent(params.get("image"))
      : variantData.image || "https://via.placeholder.com/300",
    variantId: params.get("variant_id") || variantData.variantId || "",
    quantity: params.get("quantity") ? parseInt(params.get("quantity")) : 1,
    fabricFormula:
      params.get("price_formula") || variantData.fabricFormula || "N/A",
    roomHighPricing: variantData.roomHighPricing || {},
  };

  function updateVariantDetails() {
    document
      .querySelectorAll(".variant-title")
      .forEach((el) => (el.textContent = initialData.title));
    document
      .querySelectorAll(".variant-size")
      .forEach((el) => (el.textContent = initialData.size));
    document
      .querySelectorAll(".step-variant-image, .product-image img")
      .forEach((img) => (img.src = initialData.image));
    document
      .getElementById("variant-id")
      ?.setAttribute("value", initialData.variantId);
    document
      .getElementById("hidden-quantity")
      ?.setAttribute("value", initialData.quantity);

    document.querySelectorAll(".variant-color").forEach((el) => {
      el.textContent = initialData.color;
    });

    document.querySelectorAll(".variant-color").forEach((el) => {
      const wrapper = el.closest("p, tr");
      if (!wrapper) return;
      const txt = el.textContent.trim().toLowerCase();
      if (txt === "default title" || txt === "n/a") {
        wrapper.style.display = "none";
      } else {
        wrapper.style.display = "";
      }
    });
  }

  // ---------------------- Helpers ----------------------

  function getSelectedValue(name) {
    const selectedRadio = document.querySelector(
      `input[name="${name}"]:checked`
    );
    return selectedRadio ? selectedRadio.value : null;
  }

  function cmToMeters(cm) {
    return cm / 100;
  }

  function getMassValues() {
    const heightCm = parseFloat(heightInput?.value) || 0;
    const widthCm = parseFloat(widthInput?.value) || 0;
    if (heightCm === 0 && widthCm === 0) return null;
    return `${widthCm}cm × ${heightCm}cm`;
  }

  function showAndUpdate(selector, value) {
    document.querySelectorAll(selector).forEach((element) => {
      const parent = element.closest("p, tr");
      if (!parent) return;
      const isValid =
        value !== null && value !== undefined && value !== "" && value !== "-";
      if (isValid) {
        element.textContent = value;
        parent.style.display = parent.tagName === "TR" ? "table-row" : "block";
      } else {
        parent.style.display = "none";
      }
    });
  }

  // ---------------------- DOM Elements ----------------------

  const fabricTypeSelect = document.getElementById("fabric-type");
  const heightInput = document.getElementById("height");
  const widthInput = document.getElementById("width");
  const quantityInput = document.getElementById("variant-quantity");

  // ---------------------- Price Summary Logic ----------------------

  function updateOrderSummary() {
    const quantity = parseInt(quantityInput?.value) || 1;
    const heightCm = parseFloat(heightInput?.value) || 0;
    const widthCm = parseFloat(widthInput?.value) || 0;
    const height = cmToMeters(heightCm);
    const width = cmToMeters(widthCm);
    const variantData = JSON.parse(localStorage.getItem("variantData")) || {};
    const fabricFormula =
      new URLSearchParams(window.location.search).get("price_formula") ||
      variantData.fabricFormula ||
      "N/A";

    const pricePerMeter = getPricePerMeter(
      fabricFormula === "130cm Wide Fabric"
        ? 130
        : fabricFormula === "140cm Wide Fabric"
        ? 140
        : fabricFormula === "150cm Wide Fabric"
        ? 150
        : null,
      widthCm,
      fabricFormula
    );

    const tapeSelect = document.querySelector("input[name='tape']:checked");
    const isOneToThreeTape = tapeSelect && tapeSelect.value.includes("1:3");

    const bandFactor = isOneToThreeTape ? 3 : 2;

    const fabricWidth =
      fabricFormula === "130cm Wide Fabric"
        ? 130
        : fabricFormula === "140cm Wide Fabric"
        ? 140
        : fabricFormula === "150cm Wide Fabric"
        ? 150
        : null;

    let finalPrice = 0;

    const calculatePanelPrice = (fabricWidthCm) => {
      const multiplier = isOneToThreeTape ? 3 : 2;
      const fabricWidth = fabricWidthCm / multiplier;
      if (widthCm < 1 || height <= 0) {
        return 0;
      }
      const panels = Math.ceil(widthCm / fabricWidth);
      const pricePerPanel = height * pricePerMeter;
      return panels * pricePerPanel;
    };

    // 1. Base Fabric Price
    if (fabricFormula === "Room high (Standard formula)") {
      finalPrice = width * pricePerMeter * (isOneToThreeTape ? 3 : 2);
    } else if (fabricFormula === "130cm Wide Fabric") {
      finalPrice = calculatePanelPrice(130);
    } else if (fabricFormula === "140cm Wide Fabric") {
      finalPrice = calculatePanelPrice(140);
    } else if (fabricFormula === "150cm Wide Fabric") {
      finalPrice = calculatePanelPrice(150);
    }

    // 2. Sewing Cost
    let sewingCostPerPanel = 0;
    let totalSewingCost = 0;

    if (widthCm > 0 && heightCm > 0 && fabricWidth) {
      const matchingStep = getMatchingPriceStep(fabricWidth, widthCm) || {};

      const selectedTape = document.querySelector("input[name='tape']:checked");
      const selectedHeaderType = selectedTape?.dataset.option || "ribbon";

      sewingCostPerPanel =
        selectedHeaderType === "eyelet"
          ? matchingStep.sewing_cost_per_panel_eyelet || 0
          : matchingStep.sewing_cost_per_panel_ribbon || 0;

      const panelWidthSize = fabricWidth / bandFactor;
      const numberOfPanels = Math.ceil(widthCm / panelWidthSize);

      totalSewingCost = numberOfPanels * sewingCostPerPanel;
      finalPrice += totalSewingCost;

      showAndUpdate(".add-on-price", `(+${currencySymbol}0)`);
      showAndUpdate(
        ".sewing-cost",
        `(+${currencySymbol}${totalSewingCost.toFixed(2)})`
      );
      showAndUpdate(".panel-count", numberOfPanels);
    }

    function getMatchingPriceStep(fabricWidth, widthCm) {
      const priceRules = JSON.parse(localStorage.getItem("priceRules")) || [];
      const rule = priceRules.find((rule) => rule.fabric_width === fabricWidth);
      if (!rule) return null;
      return rule.steps.find((step) => {
        const [min, max] = step.range.split("-").map(Number);
        return widthCm >= min && widthCm <= max;
      });
    }

    // 3. Subtotal
    const pricePerItem = parseFloat(finalPrice.toFixed(2));
    const subtotal = pricePerItem * quantity;

    // 4. Update DOM
    document.querySelectorAll(".add-on-price").forEach((el) => {
      el.textContent = `(+${currencySymbol}0)`;
    });

    document.querySelectorAll(".subtotal-price, .total-price").forEach((el) => {
      el.textContent = `${currencySymbol}${subtotal.toFixed(2)}`;
    });

    document.querySelectorAll(".total-hide-price").forEach((el) => {
      el.textContent = `${subtotal.toFixed(2)}`;
    });

    document.querySelectorAll(".price-per-meter").forEach((el) => {
      el.textContent = `${currencySymbol}${pricePerMeter.toFixed(2)}`;
    });

    const hiddenQty = document.getElementById("hidden-quantity");
    if (hiddenQty) hiddenQty.value = quantity;
  }

  // ---------------------- Price Per Meter ----------------------

  function getPricePerMeter(fabricWidth, fabricWidthInCm, fabricFormula) {
    const variantData = JSON.parse(localStorage.getItem("variantData")) || {};

    if (fabricFormula === "Room high (Standard formula)") {
      const selectedTape = document.querySelector("input[name='tape']:checked");
      const selectedHeaderType = selectedTape?.dataset.option || "ribbon";
      const roomHighPricing = variantData.roomHighPricing || {};
      const price =
        selectedHeaderType === "eyelet"
          ? roomHighPricing.fabric_price_eyelet
          : roomHighPricing.fabric_price_ribbon;
      return price || 0;
    }

    const priceRules = JSON.parse(localStorage.getItem("priceRules")) || [];
    const rule = priceRules.find((rule) => rule.fabric_width === fabricWidth);

    if (rule) {
      for (const step of rule.steps) {
        const [min, max] = step.range.split("-").map(Number);
        if (fabricWidthInCm >= min && fabricWidthInCm <= max) {
          return step.price_per_meter;
        }
      }
    }

    return variantData.pricePerMeter || 0;
  }

  // ---------------------- Dimension Validation ----------------------

  function validateDimensions() {
    const widthInput = document.getElementById("width");
    const heightInput = document.getElementById("height");

    const minWidthError = document.getElementById("min-width-error");
    const maxWidthError = document.getElementById("max-width-error");
    const minHeightError = document.getElementById("min-height-error");
    const maxHeightError = document.getElementById("max-height-error");

    const minWidth = parseFloat(widthInput.dataset.min);
    const maxWidth = parseFloat(widthInput.dataset.max);
    const minHeight = parseFloat(heightInput.dataset.min);
    const maxHeight = parseFloat(heightInput.dataset.max);

    let hasError = false;

    if (parseFloat(widthInput.value) < minWidth) {
      minWidthError.style.display = "inline";
      hasError = true;
    } else {
      minWidthError.style.display = "none";
    }

    if (parseFloat(widthInput.value) > maxWidth) {
      maxWidthError.style.display = "inline";
      hasError = true;
    } else {
      maxWidthError.style.display = "none";
    }

    if (parseFloat(heightInput.value) < minHeight) {
      minHeightError.style.display = "inline";
      hasError = true;
    } else {
      minHeightError.style.display = "none";
    }

    if (parseFloat(heightInput.value) > maxHeight) {
      maxHeightError.style.display = "inline";
      hasError = true;
    } else {
      maxHeightError.style.display = "none";
    }

    return !hasError;
  }

  // ---------------------- Summary Update ----------------------

  function updateSummaryTable() {
    let windowType = getSelectedValue("window_type");
    let determinationDimension = getSelectedValue("tape");
    let vorhangType = getSelectedValue("vorhang_type");
    let mass = getMassValues();

    let gliterOrEyeletValue = "";
    document
      .querySelectorAll(
        ".gleiter-options input[type='radio'], .eyelets-options input[type='radio']"
      )
      .forEach((input) => {
        if (input.checked) {
          gliterOrEyeletValue = input.value;
        }
      });

    if (gliterOrEyeletValue) {
      showAndUpdate(".gliter-eyelet-option", gliterOrEyeletValue);
      document
        .querySelector(".gliter-eyelet-option")
        .closest("p").style.display = "block";
    }

    if (windowType) showAndUpdate(".summary-window-type", windowType);
    if (determinationDimension)
      showAndUpdate(
        ".summary-determination-dimensions",
        determinationDimension
      );
    if (mass) showAndUpdate(".summary-mass", mass);
    if (vorhangType) showAndUpdate(".summary-vorhang", vorhangType);

    updateOrderSummary();
  }

  // ---------------------- Event Listeners ----------------------

  quantityInput?.addEventListener("change", updateOrderSummary);
  fabricTypeSelect?.addEventListener("change", updateOrderSummary);

  heightInput?.addEventListener("input", () => {
    validateDimensions();
    updateOrderSummary();
    updateOrderSummaryFromWorker();
  });

  widthInput?.addEventListener("input", () => {
    validateDimensions();
    updateOrderSummary();
    updateOrderSummaryFromWorker();
  });

  document.querySelectorAll('input[name="tape"]').forEach((radio) => {
    radio.addEventListener("change", () => {
      updateOrderSummary();
      updateOrderSummaryFromWorker();
    });
  });

  document
    .querySelectorAll('input[name="gliter-eyelet-option"]')
    .forEach((radio) => {
      radio.addEventListener("change", () => {
        updateOrderSummary();
        updateOrderSummaryFromWorker();
      });
    });

  // ---------------------- Preview Price (Worker) ----------------------

  let previewTimeout;

  function updateOrderSummaryFromWorker() {
    const variantData = JSON.parse(localStorage.getItem("variantData")) || {};
    const widthCm     = parseFloat(document.getElementById("width")?.value);
    const heightCm    = parseFloat(document.getElementById("height")?.value);
    const tape        = getSelectedValue("tape") || "";
    const headerType  = document.querySelector("input[name='tape']:checked")?.dataset.option || "ribbon";

    if (!variantData.variantId || isNaN(widthCm) || isNaN(heightCm)) return;

    clearTimeout(previewTimeout);
    previewTimeout = setTimeout(() => {
      fetch("https://curtain-configurator.ka-ching.workers.dev/preview", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          variantId: variantData.variantId,
          widthCm,
          heightCm,
          tape,
          headerType,
        }),
        signal: AbortSignal.timeout(5000),
      })
      .then(r => r.json())
      .then(({ price }) => {
        const formatted = parseFloat(price).toFixed(2);
        document.querySelectorAll(".total-price, .subtotal-price").forEach(el => {
          el.textContent = `${currencySymbol}${formatted}`;
        });
        document.querySelectorAll(".total-hide-price").forEach(el => {
          el.textContent = formatted;
        });
      })
      .catch(() => { /* client-side updateOrderSummary remains active as fallback */ });
    }, 400);
  }

  // ---------------------- Add to Cart ----------------------

  function handleAddToCart(event) {
    event.preventDefault();

    const variantData = JSON.parse(localStorage.getItem("variantData")) || {};
    const quantity    = parseInt(document.getElementById("variant-quantity")?.value) || 1;
    const widthCm     = parseFloat(document.getElementById("width")?.value);
    const heightCm    = parseFloat(document.getElementById("height")?.value);

    if (!variantData.variantId) {
      alert("Bitte gehe zurück zum Produkt und wähle eine Variante.");
      return;
    }
    if (isNaN(widthCm) || isNaN(heightCm)) {
      alert("Bitte Breite und Höhe angeben.");
      return;
    }

    const tape       = getSelectedValue("tape") || "";
    const headerType = document.querySelector("input[name='tape']:checked")?.dataset.option || "ribbon";

    const variantColor = variantData.color && variantData.color.toLowerCase() !== "n/a"
      ? variantData.color
      : null;

    const properties = {
      "Farbe":          variantColor,
      "Aufhängungsart": getSelectedValue("window_type"),
      "Band":           tape,
      "Gleiter/Ösen":   getSelectedValue("gliter-eyelet-option"),
      "Maß":            getMassValues(),
      "Vorhänge":       getSelectedValue("vorhang_type"),
    };
    Object.keys(properties).forEach(k => { if (!properties[k]) delete properties[k]; });

    fetch("https://curtain-configurator.ka-ching.workers.dev/calculate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        variantId:  variantData.variantId,
        widthCm:    widthCm,
        heightCm:   heightCm,
        tape:       tape,
        headerType: headerType,
      }),
      signal: AbortSignal.timeout(10000),
    })
    .then(r => {
      if (!r.ok) throw new Error(`Worker error: ${r.status}`);
      return r.json();
    })
    .then(({ variantId }) => {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: parseInt(variantId), quantity, properties }),
        signal: AbortSignal.timeout(8000),
      });
    })
    .then(r => r.json())
    .then(() => updateCartDrawer(true))
    .catch(err => {
      console.error("Cart error:", err);
      alert("Fehler beim Hinzufügen zum Warenkorb. Bitte erneut versuchen.");
    });
  }

  // ---------------------- Cart Drawer ----------------------

  function updateCartDrawer(openMiniCart = true) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCountElement = document.querySelector(".header__cart-count");
        if (cartCountElement) {
          cartCountElement.textContent = cart.item_count ?? 0;
        }
        return fetch(
          `${window.themeVariables.routes.cartUrl}?section_id=mini-cart`
        );
      })
      .then((response) => response.text())
      .then((html) => {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.innerHTML = new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector("cart-drawer").innerHTML;
        }
        if (openMiniCart) {
          openCartDrawer();
        }
      })
      .catch((error) => console.error("Error updating cart drawer:", error));
  }

  function openCartDrawer() {
    const cartDrawer = document.getElementById("mini-cart");
    if (cartDrawer) {
      cartDrawer.setAttribute("open", "true");
      document.body.classList.add("overflow-hidden");
    }
  }

  // ---------------------- Quantity Input ----------------------

  document
    .querySelector("#variant-quantity")
    ?.addEventListener("input", function () {
      const newQuantity = parseInt(this.value) || 1;
      localStorage.setItem("selectedQuantity", newQuantity);
      updateOrderSummary();
      const variantQuantityEl = document.querySelector(
        ".order-summary .variant-quantity"
      );
      if (variantQuantityEl) {
        variantQuantityEl.textContent = parseInt(this.value) || 1;
      }
    });

  document
    .querySelector(".next-btn")
    ?.addEventListener("click", function (event) {
      if (!validateDimensions()) {
        event.preventDefault();
        return;
      }
      updateSummaryTable();
    });

  document
    .querySelector(".add-to-cart-btn")
    ?.addEventListener("click", handleAddToCart);


  updateVariantDetails();
  updateOrderSummary();
});
